import React from 'react';
import { StyledColumnDimensionHeader } from './styled';
import Search from './Search';
import DimensionDropdown from '../DimensionDropdown';

const DimensionHeader = () => {
  return (
    <StyledColumnDimensionHeader>
      <DimensionDropdown />
      <div className="column-info">
        <Search />
      </div>
    </StyledColumnDimensionHeader>
  );
};

export default DimensionHeader;
